const sortSocialArray = (obj1, obj2) => obj1.order - obj2.order;

export default sortSocialArray;
